import { Button } from '@/components/button';
import { useTranslation } from '@/contexts/i18n-context';
import { ErrorLayout } from '@/components/error-layout';

export function SsoErrorPage() {
  const { t } = useTranslation();

  return (
    <ErrorLayout
      withoutButton
      title={t('ssoError.title')}
      description={t('ssoError.description', {
        support: (
          <Button variant="link" as="a" to="/support" key="sso-error-support">
            {t('ssoError.support')}
          </Button>
        ),
      })}
    />
  );
}
